import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';


import "@fancyapps/ui/src/Fancybox/Fancybox.js";
import '../../customCSS/MyFancybox.css';
function Image({src,className,alt,placeholder,afterLoad,beforeLoad,fancybox}) {
  return (
    <LazyLoadImage
    alt={alt}
    beforeLoad={beforeLoad }
    afterLoad={afterLoad }
   
    className={className}
    effect={'blur'}
    
    
    placeholderSrc={placeholder || src || 'https://storage.googleapis.com/proudcity/mebanenc/uploads/2021/03/placeholder-image.png'}
    scrollPosition={null}
    src={src}
    threshold={100}
  
  
    data-fancybox={fancybox || 'single image'}
    data-src={src ||placeholder}
    wrapperClassName="gallery-img-wrapper" />
  )
}

export default Image